export default "__VITE_ASSET__DGDnFRnH__"